import {AllScoresLinkParams} from "./all-scores-container-link-params";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {BaseLinkModelSettings} from "../../../infrastructure/models/link/base-link-model-settings";
import {APP} from "../../../core/app/consts";
import {DASHBOARD} from "../../dashboard-container/dashboard-container.consts";
import {AllScoresHashParamsModel} from "./all-scores.hash-params-model";

export class AllScoresLinkModel extends BaseLinkModel  {
  constructor(filter: String = '', sportName: String = '', resetState: Boolean = false, refreshPage: Boolean = false, hashParams: AllScoresHashParamsModel = null, isLinkTag: Boolean = true) {
    super(ROUTE_NAMES.allScores, new AllScoresLinkParams(sportName, filter), false, null, null, hashParams, isLinkTag);

    this.settings = new BaseLinkModelSettings(refreshPage, resetState);
    this.screen = filter === DASHBOARD.FILTERS.live ? APP.ANALYTICS.SOURCES.liveScores : APP.ANALYTICS.SOURCES.scores;
  }
}